import dayjs from 'dayjs'

export function makeColumnDefs () {
  const columnDefs = []

  columnDefs.push({
    headerName: 'Entity',
    valueGetter: function (cellParams) {
      return cellParams.data.name
    },
    cellRenderer: function (cellParams) {
      return `<a href="/app/admin/entity/${cellParams.data.organisation_id}">${cellParams.data.name}</a>`
    },
    pinned: 'left'
  })

  columnDefs.push({
    headerName: 'Status',
    valueGetter: function (cellParams) {
      return cellParams.data.status
    },
    cellRenderer: function (cellParams) {
      return `<a href="/app/admin/data-syncs/${cellParams.data.data_sync_id}">${cellParams.data.status}</a>`
    }
  })

  columnDefs.push({
    headerName: 'Origin',
    valueGetter: function (cellParams) {
      return cellParams.data.origin
    },
    cellRenderer: function (cellParams) {
      return cellParams.data.origin
    }
  })

  columnDefs.push({
    headerName: 'Scheduled',
    valueGetter: function (cellParams) {
      return cellParams.data.scheduled_time
    },
    cellRenderer: function (cellParams) {
      if (!cellParams.value) return null

      return dayjs(cellParams.value).format('DD MMM YYYY HH:mm:ss')
    }
  })

  columnDefs.push({
    headerName: 'Started',
    valueGetter: function (cellParams) {
      return cellParams.data.started_at
    },
    cellRenderer: function (cellParams) {
      if (!cellParams.value) return null

      return dayjs(cellParams.value).format('DD MMM YYYY HH:mm:ss')
    }
  })

  columnDefs.push({
    headerName: 'Ended',
    valueGetter: function (cellParams) {
      return cellParams.data.ended_at
    },
    cellRenderer: function (cellParams) {
      if (!cellParams.value) return null

      return dayjs(cellParams.value).format('DD MMM YYYY HH:mm:ss')
    }
  })

  columnDefs.push({
    headerName: 'Created',
    valueGetter: function (cellParams) {
      return cellParams.data.created_at
    },
    cellRenderer: function (cellParams) {
      if (!cellParams.value) return null

      return dayjs(cellParams.value).format('DD MMM YYYY HH:mm:ss')
    }
  })

  columnDefs.push({
    headerName: 'Modules',
    valueGetter: function (cellParams) {
      return cellParams.data.number_of_modules
    },
    type: 'numericColumn'
  })

  columnDefs.push({
    headerName: 'Steps',
    valueGetter: function (cellParams) {
      return cellParams.data.number_of_steps
    },
    type: 'numericColumn'
  })

  columnDefs.push({
    headerName: 'Errors',
    valueGetter: function (cellParams) {
      return cellParams.data.number_of_errors
    },
    type: 'numericColumn'
  })

  return columnDefs
}
